import { AlertDialog, Button, Text } from '@buffer-mono/popcorn'

import { useDeleteSavedViewMutation } from './hooks'
import type { SavedView } from './hooks'
import type { DialogOpenProps } from './types'

import type { JSX } from 'react'

type DeleteViewAlertDialogProps = DialogOpenProps & { view: SavedView }

/** Confirmation dialog for deleting a saved view. */
export function DeleteViewAlertDialog({
  view,
  open,
  onOpenChange,
}: DeleteViewAlertDialogProps): JSX.Element {
  const [deleteSavedView, { loading }] = useDeleteSavedViewMutation()

  const handleConfirm = async (): Promise<void> => {
    const outcome = await deleteSavedView(view)
    if (outcome.success) {
      onOpenChange(false)
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Content>
        <AlertDialog.Title>Delete &quot;{view.name}&quot;?</AlertDialog.Title>
        <AlertDialog.Description>
          <Text>
            This will remove the saved view. You can always create a new one.
          </Text>
        </AlertDialog.Description>
        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary" size="large" type="button">
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <Button
            variant="critical"
            size="large"
            loading={loading}
            disabled={loading}
            onClick={(): void => {
              void handleConfirm()
            }}
          >
            Delete
          </Button>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
